import React from 'react';

import CartResumeCard from '@/resources/components/cart/cartResumeCard/CartResumeCard';
import ComboResumeCard from '@/resources/components/cart/comboResumeCard/comboResumeCard';
import DeleteAllCart from '@/resources/components/cart/reviewItemModal/DeleteAllCart';
import Subtotal from '@/resources/components/cart/subtotal/Subtotal';
import { ICartCombo } from '@/store/ducks/combos/types';
import { ICartProduct } from '@/store/ducks/order/types';

import { formatToBestCombo } from '../../../product/default/utils/comboUtils';
import { getComboName, groupComboProducts, separateProducts } from '../utils/cartUtils';

interface CartProductsListProps {
  order: any;
  combos: ICartCombo[];
  setEditProducts: (products: any) => void;
  setProductToCombo: (productToCombo: any) => void;
}

const CartProductsList: React.FC<CartProductsListProps> = ({
  order,
  combos,
  setEditProducts,
  setProductToCombo,
}) => {
  const { comboProducts, regularProducts } = separateProducts(order.cart.products);
  const comboGroups = groupComboProducts(comboProducts);

  const handleComboEdit = (products: ICartProduct[], comboId: number) => {
    const formattedCombo = formatToBestCombo(combos.find((c) => c.id === comboId));
    if (!formattedCombo) return;

    setEditProducts(products);
    setProductToCombo({
      best_combo: formattedCombo,
    });
  };

  return (
    <>
      <ul className="list-unstyled mb-0 w-100">
        {combos?.length
          ? Object.entries(comboGroups).map(([comboSeqId, products]) => {
              const comboId = products[0]?.combo_id;
              const comboName = getComboName(combos, comboId, comboSeqId);

              return (
                <ComboResumeCard
                  key={`combo-${comboSeqId}`}
                  comboName={comboName}
                  onEdit={() => handleComboEdit(products, comboId)}
                >
                  {products.map((product: ICartProduct) => (
                    <CartResumeCard key={`combo-product-${product.product_id}`} item={product} />
                  ))}
                </ComboResumeCard>
              );
            })
          : null}

        {regularProducts.map((product) => {
          return (
            product && (
              <CartResumeCard
                item={product}
                key={`cart-item-${product.product_id}-${product.ean}`}
              />
            )
          );
        })}
      </ul>

      <div className="d-flex justify-content-end">
        <DeleteAllCart />
      </div>

      <hr className="mb-2 mt-1" />

      <Subtotal subtotal cart={order.cart} />
    </>
  );
};

export default CartProductsList;
